import Reflux from "reflux";

import Chip from "@javascript/reactComponents/lds/chips/Chip";
import FacetSearchStore from "@javascript/stores/facetSearchStore";
import { FacetSearchStoreActions } from "@javascript/stores/actions/facetSearch/storeActions";

const FacetSearchCriteriaClinicalTrialStages = createReactClass({
  mixins: [
    Reflux.connectFilter(FacetSearchStore, function (data) {
      return {
        display: data.clinicalTrialStages.display,
        selected: data.clinicalTrialStages.selected,
      };
    }),
  ],
  getInitialState() {
    return {
      display: FacetSearchStore.data.clinicalTrialStages.display,
      selected: FacetSearchStore.data.clinicalTrialStages.selected,
    };
  },
  shouldComponentUpdate: function (nextProps, nextState) {
    return this.state.selected.length !== nextState.selected.length;
  },
  render() {
    if(this.state.selected.length === 0) {
      return null;
    }
    else {
      // Zymewire.original_feed_query should probably be refactored to the FacetSearchStore under
      // searchTerms.originalQuery key
      // set on initial view, updated on any subsequent AJAX success
      const originalQuery = Zymewire.original_feed_query;

      let lastIndex = this.state.selected.length - 1

      let selectedList = this.state.selected.map((stage, index) => {

        let last = index === lastIndex;
        let name = this.state.display[stage];
        let locked = false;

        if (originalQuery) {
          if (originalQuery.clin_stage && originalQuery.clin_stage.length > 0) {
            if (_.contains(originalQuery.clin_stage, stage)) {
              locked = true;
              // this hide is ugly hacky and once we connect the clinical trial stages selector to the store in a future
              // refactor, we can safely junk this
              $('#trial_stages_panel').hide();
            }
          }
        }
        return <ClinicalTrialAppliedFilterEntry
          key={index}
          last={last}
          locked={locked}
          name={name}
          stage={stage}
        />
      });

      return(
        <>
          {selectedList}
        </>
      )
    }
  }
});

const ClinicalTrialAppliedFilterEntry = ({
  last,
  locked,
  name,
  stage,
}) => {


  let removeStage = (e) => {

    const clinicalTrialStagesSelected = [...FacetSearchStore.data.clinicalTrialStages.selected];
    const selectedIndex = clinicalTrialStagesSelected.indexOf(stage);

    if (selectedIndex > -1) {
      // remove the clinical trial stage from the array... we no longer wish to represent it as checked
      clinicalTrialStagesSelected.splice(selectedIndex, 1);
    } else {
      // add the clinical trial stage to the array... it should be checked now
      clinicalTrialStagesSelected.push(stage);
    }
    FacetSearchStoreActions.clinicalTrialStagesUpdate(
      { selected: clinicalTrialStagesSelected },
      { doSearch: true, triggerStateUpdate: false }
    );

    return false;
  };

  const label = (
    <>
      {Zymewire.facet_search_filters.trial_phases}: {name}
      {!last && <b> OR</b>}
    </>
  );

  return (
    <Chip
      className="search_filter_applied_chip"
      label={label}
      leadingIcon="phase"
      size="small"
      {...!locked && {
        trailingIcon: "cancel",
        trailingIconClassName: "search_filter_applied_trailing_icon",
        trailingIconOnClick: removeStage,
      }}
      variant="secondary"
    />
  );
};

window.FacetSearchCriteriaClinicalTrialStages = FacetSearchCriteriaClinicalTrialStages;
export default FacetSearchCriteriaClinicalTrialStages;
